"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaDatas = void 0;
exports.MetaDatas = {
    VIRTUAL_MODEL: 'VIRTUAL_MODEL',
    WHITELIST_MODEL: 'WHITELIST_MODEL',
    BLACKLIST_MODEL: 'BLACKLIST_MODEL',
    SEARCHABLE_MODEL: 'SEARCHABLE_MODEL',
};
